(function () {
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxvy2Io7y5VXsNw3KPlEw-oAWLVMgvRR4ZMoXBEcOiD-TE3D3k270BBvjOrOIWJS6SI/exec";

  let lastQuery = "";
  let lastSentQuery = "";

  function sendToSheet(trigger) {
    if (!lastQuery || lastQuery === lastSentQuery) return;

    lastSentQuery = lastQuery;

    const payload = JSON.stringify({
      search_term: lastQuery,
      trigger: trigger, // predictive_click | enter
      page_url: window.location.href,
      user_agent: navigator.userAgent
    });

    // Reliable for navigation events
    if (navigator.sendBeacon) {
      navigator.sendBeacon(SCRIPT_URL, payload);
    } else {
      fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: payload
      });
    }
  }

  /* 1️⃣ Capture what user types */
  document.addEventListener("input", function (e) {
    if (e.target.matches('input[name="q"]')) {
      lastQuery = e.target.value.trim();
    }
  });

  /* 2️⃣ Predictive search result click */
  document.addEventListener("click", function (e) {
    const predictiveLink = e.target.closest(
      '.predictive-search__item a, [role="option"] a, .predictive-search__list-item a'
    );

    if (predictiveLink) {
      sendToSheet("predictive_click");
    }
  }, true);

  /* 3️⃣ Enter key / full search submit */
  document.addEventListener("submit", function (e) {
    if (e.target.matches('form[action="/search"]')) {
      sendToSheet("enter");
    }
  });

})();